import { GrandRadioCard } from 'ui'
import { Text, VStack } from '@chakra-ui/react'
import { type Language, type PickupDTO } from 'ecosystem'
import { countryNames } from 'shared-utils'

type PostNordPickupCardProps = {
  pickup: PickupDTO
}

export const PostNordPickupCard = ({ pickup }: PostNordPickupCardProps) => {
  const locale = (document?.documentElement.lang ?? 'sv') as Language
  const country = pickup.address.country && countryNames[locale][pickup.address.country]
  return (
    <GrandRadioCard.Item value={pickup.id}>
      <GrandRadioCard.ItemControl>
        <GrandRadioCard.Indicator />
        <GrandRadioCard.ItemContent>
          <GrandRadioCard.ItemText>{pickup.name}</GrandRadioCard.ItemText>

          <VStack align="flex-start" gap={1}>
            {pickup.address.address1 && (
              <GrandRadioCard.ItemDescription fontWeight="medium">
                {pickup.address.address1}

                {pickup.address.address2 && <Text as="span">{`, ${pickup.address.address2}`}</Text>}
              </GrandRadioCard.ItemDescription>
            )}

            {!pickup.address.address1 && pickup.address.address2 && (
              <GrandRadioCard.ItemDescription fontWeight="medium">
                {pickup.address.address2}
              </GrandRadioCard.ItemDescription>
            )}

            <GrandRadioCard.ItemDescription fontWeight="medium">
              {pickup.address.postalCode && `${pickup.address.postalCode} `}
              {pickup.address.postalRegion}
              {country && `, ${country}`}
            </GrandRadioCard.ItemDescription>

            {pickup.address.mobilePhone && (
              <GrandRadioCard.ItemDescription>
                {pickup.address.mobilePhone}
              </GrandRadioCard.ItemDescription>
            )}

            {pickup.address.attention && (
              <GrandRadioCard.ItemDescription>
                {pickup.address.attention}
              </GrandRadioCard.ItemDescription>
            )}

            {pickup.address.reference && (
              <GrandRadioCard.ItemDescription>
                {pickup.address.reference}
              </GrandRadioCard.ItemDescription>
            )}
          </VStack>
        </GrandRadioCard.ItemContent>
      </GrandRadioCard.ItemControl>
    </GrandRadioCard.Item>
  )
}
